import { React, useCallback, useEffect, useState, useContext } from 'react'
import { FaEdit, FaAngleDown, FaAngleRight } from "react-icons/fa";
import SubHeader from './SubHeader';
import Select from 'react-select';
import axios from '../../api/axios';
import Profile from '../../assets/images/profile-img.png';
import { toast } from 'react-toastify';
import { Col, Form, FormGroup, Label, Input, NavLink, Row, ListInlineItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { GlobalContext } from '../../App';
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import TopHeader from './TopHeader';
import { BsChevronRight } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
function ManageUsers(...args) {
  const navigate = useNavigate();
  const body = document.body;
  const mainPanel = document.querySelector('.main-panel');
  const maskBgOverlay = document.createElement('div');
  maskBgOverlay.id="maskBgOverlay";
  maskBgOverlay.className = 'maskBgOverlay';
  const location = useLocation();
  const { pathname } = location;
  const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
  var [roleList, setRoleList] = useState([]);
  const [userData, setUserData] = useState({
    name: null,
    username: null,
    email: null,
    contact: null,
    roleData: [],
    password: null,
    updateId: null
  });
  const [userDataList, setUserDataList] = useState([]);
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [projectStructure, setProjectStructure] = useState([]);
  const [milestoneStructure, setMilestoneStructure] = useState([]);
  const [taskStructure, setTaskStructure] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [userStatus, setUserStatus] = useState("Active");
  const { rolexModuleData,roles,user_id,userProfile} = useContext(GlobalContext);
  const isUpdateAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.update === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;
  const [tasklistisOpen, tasklistsetIsOpen] = useState('1');
  const [ProjectAccessList, setProjectAccessList] = useState({
    project: [],
    milestone: [],
    task: []
  })
  const [validPwd, setValidPwd] = useState(false);
  const [passwordStatus,setPasswordStatus] = useState('password'); 
 const [loading, setLoading] = useState(true); 
   // Handle Error
   const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
  // ------------------------------------------------------ Get Role --------------------------------------------
  const getRoleList = () => {
    setLoading(true);
    axios.get('/getRoleList').then((response) => {
            const roleList = response?.data?.map(item => ({ label: item?.role, value: item?.id })) ?? [];
      setRoleList(roleList);
      setLoading(false);
    }).catch(handleError);
  };
  
  // ------------------------------------------------------- Add User --------------------------------------------
  const postAddUser = (e) => {
    const v2 = PWD_REGEX.test(userData?.password);
      if (userData?.name === null || userData?.name === "") {
        e.preventDefault();
        toast.error("Name is required!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
      else if (userData?.username === null || userData?.username === "") {
        e.preventDefault();
        toast.error("Username is required!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
      else if (userData?.password === null || userData?.password === "") {
        e.preventDefault();
        toast.error("Password is required!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
      else if (!v2 && userData?.updateId === null) {
        toast.error("Password must be of 8 to 24 characters - 1 uppercase, 1 lowercase, 1 number and a special character!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
      else if (userData?.email === null || userData?.email === "") {
        e.preventDefault();
        toast.error("Email ID is required!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
      else if (userData?.contact === null || userData?.contact === "") {
        e.preventDefault();
        toast.error("Phone Number is required!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
      else if (userData?.roleData?.length <= 0) {
        e.preventDefault();
        toast.error("User role is required!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
      else {
        const params = {
          userData: userData,
          ProjectAccessList: ProjectAccessList,
          user_id:user_id
        }
        axios.post('/postAddUser', params).then((response)=>{
          if (response.status === 202) {
            e.preventDefault();
            toast.error("Username already exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000
            });
          }
          else if (response.status === 204) {
            e.preventDefault();
            toast.error("Email Id already exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000
            });
          }
          else {
            toast.success(`User is ${userData?.updateId != null ? "updated" : "created"} successfully!`, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000
            });
            setUserData({ ...userData, name: null, username: null, email: null, contact: null, roleData: [], password: null, updateId: null, company : [],bu: [],department: [] })
            handleClose();
            getUserData();
          }
        }).catch(handleError);
      }
  }
  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    setLoading(true);
    const UserListCriteria  =  rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? '' : userProfile || '';
    axios.get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`).then((response, error) => {
        setUserDataList(response?.data?.[0]?.user_data);
        setLoading(false);
      }).catch(handleError);
  }
  // --------------------------------------------------------- Update User Data -----------------------------------
  const updateActiveStatus =(e, status, id) => {
    e.preventDefault();
      const params = {
        isActive: status,
        id: id,
        user_id:user_id
      }
      axios.post('/updateActiveStatus', params).then((response)=>{
        if (response.status === 202) {
          toast.success("Status Update Successfully", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000
          });
          getUserData();
        }
      }).catch(handleError);
  }
  const updateUserData = (id) => {
    const user = userDataList.find((user) => user.user_id === id);
    if (!user) return;
  
    const {
      name,
      contact_number,
      user_x_role,
      username,
      email_id,
      password,
      user_x_project,
      user_x_milestone,
      user_x_task,
    } = user;  
    const tempRoleData = (user_x_role || []).map((ur) => ({
      label: ur?.role_master?.[0]?.role,
      value: ur?.role_master?.[0]?.id,
    }));
  
    const projectArray = (user_x_project || []).map((data) => ({
      project_id: data?.project_id,
      project_access: data?.project_access,
    }));
  
    const milestoneArray = (user_x_milestone || []).map((data) => ({
      project_id: data?.project_id,
      milestone_id: data?.milestone_id,
      milestone_access: data?.milestone_access,
    }));
  
    const taskArray = (user_x_task || []).map((data) => ({
      project_id: data?.project_id,
      milestone_id: data?.milestone_id,
      task_id: data?.task_id,
      task_access: data?.task_access,
    }));
  
    setProjectAccessList({
      project: projectArray,
      milestone: milestoneArray,
      task: taskArray,
    });
  
    const newUserData = {
      name,
      username,
      email: email_id,
      contact: contact_number,
      password,
      roleData: tempRoleData,
      updateId: id,
    };  
    setUserData(newUserData);
  
    setModal(true);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };   
  // ----------------------------------------------------------- Handle Close ---------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    setUserData({ ...userData, name: null, username: null, email: null, contact: null, roleData: [], password: null, updateId: null});
    setProjectAccessList({ project: [], milestone: [], task: [] });
    body.style.overflow = "";
    document.getElementById("maskBgOverlay").remove();
  }
  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  }
  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  }
  // ------------------------------------------------------------- Get Task List ---------------------------------
  const getTaskList = () => {
    setLoading(true);
      axios.post('/getTaskList').then((response)=>{
        const taskList = response?.data?.[0]?.task_data?.map(item => ({ label: item?.task_title, value: item?.task_id,projectId:item?.project_id,milestoneId:item?.milestone_id })) ?? [];
        setTaskStructure(taskList); 
        setLoading(false); 
      }).catch(handleError);
  }
  // ------------------------------------------------------------- Get Project List ---------------------------------
  const getProjectList = () => {
    setLoading(true);
    axios.get('/getProjectList').then((response)=>{
      const projectList = response?.data?.[0]?.project_data?.map(item => ({ label: item?.project_title, value: item?.project_id, projectOwner: item?.project_x_owner })) ?? [];
      setProjectStructure(projectList);
      setLoading(false);
      }).catch(handleError);
  }
  // ------------------------------------------------------------- Get Milestone List ---------------------------------
  const getMilestoneList = () => {
    setLoading(true);
       axios.post('/getMilestoneList').then((response)=>{
       const milestoneList = response?.data?.[0]?.milestone_data?.filter((obj, index, arr) => arr.findIndex(o => o.milestone_id === obj.milestone_id) === index)?.map(item => ({ label: item?.milestone_title, value: item?.milestone_id, projectId: item?.project_id, })) ?? [];
       setMilestoneStructure(milestoneList);
       setLoading(false);
      }).catch(handleError);
  }
  // -------------------------------------------------------------- Set Project Access ----------------------------------
  const setProjectAccess = (index, data) => event => {
    const dataArray = ProjectAccessList?.project ? [...ProjectAccessList.project] : [];
    const milestoneArray = ProjectAccessList?.milestone ? [...ProjectAccessList.milestone] : [];
    const taskArray = ProjectAccessList?.task ? [...ProjectAccessList.task] : [];
    if (dataArray?.find((data1) => data1.project_id === data.value)) {
      dataArray.forEach(data1 => {
        if (data1.project_id === data.value) {
          data1.project_access = event.target.checked ? 1 : 0;
          milestoneArray.forEach(milestone => {
            if (milestone.project_id === data?.value) {
              milestone.milestone_access = event.target.checked ? 1 : 0;
              taskArray.forEach(task => {
                if (task.milestone_id === milestone.milestone_id) {
                  task.task_access = event.target.checked ? 1 : 0;
                }
              });
            }
          });
        }
      })
    } 
    else {
      dataArray.push({ project_id: data?.value, project_access: event.target.checked ? 1 : 0 });
      milestoneStructure
        .filter(milestoneData => milestoneData?.projectId === data?.value)
        .forEach(milestoneData => {
          milestoneArray.push({ project_id: data?.value, milestone_id: milestoneData?.value, milestone_access: event.target.checked ? 1 : 0 });
          taskStructure
          .filter(taskData => taskData?.milestoneId === milestoneData?.value)
          .forEach(taskData => {
            taskArray.push({ project_id: data?.value, milestone_id: taskData?.milestoneId, task_id: taskData?.value, task_access: event.target.checked ? 1 : 0 });
          });
        });
    }
    setProjectAccessList({ project: dataArray, milestone: milestoneArray, task: taskArray });
  };
  // -------------------------------------------------------------- Set Milestone Access --------------------------------
  const setMilestoneAccess = (index, data) => event => {
    const dataArray = ProjectAccessList?.milestone ? [...ProjectAccessList?.milestone] : [];
    const taskArray = ProjectAccessList?.task ? [...ProjectAccessList.task] : [];
    if (dataArray?.find((data1) => data1.milestone_id === data.value)) {
      dataArray.forEach(data1 => {
        if (data1.milestone_id === data.value) {
          data1.milestone_access = event.target.checked ? 1 : 0;
          taskArray.forEach(task => {
            if (task.milestone_id === data.value) {
              task.task_access = event.target.checked ? 1 : 0;
            }
          });
        }
      });

    }
    else {
      dataArray.push({ project_id: data.projectId, milestone_id: data?.value, milestone_access: event.target.checked ? 1 : 0 });
      milestoneStructure
        .filter(milestoneData => milestoneData?.projectId === data?.value)
        taskStructure
        .filter(taskData => taskData?.milestoneId === data?.value)
        .forEach(taskData => {
          taskArray.push({ project_id: data.projectId, milestone_id: taskData?.milestoneId, task_id: taskData?.value, task_access: event.target.checked ? 1 : 0 });
        });
    }
    setProjectAccessList({ ...ProjectAccessList, milestone: dataArray, task: taskArray });
  }
  // -------------------------------------------------------------- Set Task Access -------------------------------------
  const setTaskAccess = (index, data) => event => {
    const dataArray = ProjectAccessList?.task ? [...ProjectAccessList?.task] : [];
    if (dataArray?.find((data1) => data1.task_id === data.value)) {
      dataArray.forEach(data1 => {
        if (data1.task_id === data.value) {
          data1.task_access = event.target.checked ? 1 : 0;
        }
      });
    }
     else {
      dataArray.push({ project_id:data.projectId,milestone_id:data.milestoneId,task_id: data?.value, task_access: event.target.checked ? 1 : 0 });
    }
    setProjectAccessList({ ...ProjectAccessList, task: dataArray });
  }
  //  ----------------------------------------------------------------- set User Content ------------------------------
  const userContent = <Form className="modelform" >
    <FormGroup>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label htmlFor="name">
              Name*
            </Label>
            <Input type="text" id="name" name="name" value={userData?.name || ""} onChange={(e) => setUserData({ ...userData, name: e.target.value })} disabled={userData?.updateId > 0 ? true : false} />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label htmlFor="userName">
              Username*
            </Label>
            <Input type="text" id="userName" name="userName" value={userData?.username || ""} onChange={(e) => setUserData({ ...userData, username: e.target.value })} disabled={userData?.updateId > 0 ? true : false} />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label htmlFor="userPassword">
              Password*
              {userData?.updateId > 0 ? null :
                <>
                  <FontAwesomeIcon icon={faCheck} className={validPwd ? "valid" : "hide"} />
                  <FontAwesomeIcon icon={faTimes} className={validPwd || !userData?.password ? "hide" : "invalid"} /></>}

            </Label>
            <div className='input-icon'>
            {passwordStatus === "password" ? < NavLink className="icon" onClick={() => setPasswordStatus("text")} ><BsEyeSlash /></NavLink> :
             <NavLink className="icon" onClick={() => setPasswordStatus("password")} ><BsEye /></NavLink>}
            <Input type={passwordStatus} id="userPassword" name="password" value={userData?.updateId > 0 ? '**********' : userData?.password || ""} onChange={(e) => setUserData({ ...userData, password: e.target.value })} disabled={userData?.updateId > 0 ? true : false} aria-invalid={validPwd ? "false" : "true"} />
            </div>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label htmlFor="userEmail">
              Email ID*
            </Label>
            <Input type="email" id="userEmail" name="email" value={userData?.email || ""} onChange={(e) => setUserData({ ...userData, email: e.target.value })} />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label htmlFor="userPhone">
              Phone Number
            </Label>
            <Input type="number" id="userPhone" name="contact" maxLength={12} value={userData?.contact || ""}
              onChange={(e) => {
                const inputValue = e.target.value.replace(/\D/g, "").slice(0, 12);
                setUserData({ ...userData, contact: inputValue });
              }} />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label htmlFor="userRole">
              User Role*
            </Label>
            <Select
              classNamePrefix="react-select"
              className="multi-select"
              menuPlacement="top"
              maxMenuHeight={200}
              onChange={(select) => setUserData({ ...userData, roleData: select })}
              options={roleList}
              value={userData?.roleData || ""}
              isMulti
              // {...props}
              theme={theme => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: 'rgba(2, 137, 255,.2)',
                  primary50: 'rgba(2, 137, 255,.2)',
                  primary75: 'rgba(2, 137, 255,.2)',
                  primary: '#0289ff',
                }
              })}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className='tasklistwrap'>
            <div className='projectheading'>
              <h5>All List</h5>
            </div>
            <div className='tasklistcontent'>
              <div className='projectlist'>
              <h6>Level 0</h6>
                <ul>
                  {projectStructure?.length > 0 ? projectStructure?.map((data, index) =>
                  (<li className={tasklistisOpen === '2' ? "task-list" : "task-list  tasklist-open"}>
                    <div className="sec-heading" >
                      <span className='downicon' onClick={() => tasklistsetIsOpen(tasklistisOpen === '2' ? '3' : '2')}>
                        {(ProjectAccessList?.project?.filter((data1) => data1.project_id === data.value)?.[0]?.project_access === 1) ? <FaAngleDown /> : <FaAngleRight />}

                      </span>
                      <input type="checkbox" name="chkProjects" id="chkProjects" checked={(ProjectAccessList?.project?.filter((data1) => data1.project_id === data.value)?.[0]?.project_access === 1) ? true : false} onChange={setProjectAccess(index, data)} />
                      <span className="ms-2">{data?.label}</span>
                    </div>
                    {(ProjectAccessList?.project?.filter((data1) => data1.project_id === data.value)?.[0]?.project_access === 1) ?
                      <ul>
                        {milestoneStructure?.length > 0 ? milestoneStructure?.filter((data1) => data1?.projectId === data?.value)?.map((data1, index1) => (
                          <>
                          <h6>Level 1</h6>
                          <li className={"task-list  tasklist-open"}>  <div className="sec-heading">
                            <span className='downicon' onClick={() => tasklistsetIsOpen(tasklistisOpen === '3' ? '4' : '3')}>
                              {(ProjectAccessList?.milestone?.filter((data2) => data2.milestone_id === data1.value)?.[0]?.milestone_access === 1) ? <FaAngleDown /> : <FaAngleRight />}
                            </span>
                            <input type="checkbox" name="chkProjects" id="chkProjects" checked={(ProjectAccessList?.milestone?.filter((data2) => data2.milestone_id === data1.value)?.[0]?.milestone_access === 1) ? true : false} onChange={setMilestoneAccess(index1,data1)} />
                            <span className="ms-2">{data1?.label}</span>
                          </div>
                            {(ProjectAccessList?.milestone?.filter((data2) => data2.milestone_id === data1.value)?.[0]?.milestone_access === 1) ?
                              <ul>
                                <h6>Tasks </h6>
                                {taskStructure?.length > 0 ?
                                          taskStructure?.filter((data2) => data2?.milestoneId === data1?.value)?.map((data2, index3) => (
                                            <li className='sublist'>
                                              <div className="sec-heading">
                                                <input type="checkbox" name="chkProjects" id="chkProjects" checked={(ProjectAccessList?.task?.filter((data3) => data3.task_id === data2.value)?.[0]?.task_access === 1) ? true : false} onChange={setTaskAccess(index3, data2)} />
                                                <span className="ms-2">{data2?.label}</span>
                                              </div>
                                            </li>
                                          ))
                                          : <li className="ms-3">There are no tasks!</li>}
                              </ul>
                              : null}

                          </li>
                          </>
                         
                        )) : <li className="ms-3">There are no level 1 data!</li>}
                      </ul> : null}

                  </li>)
                  ) : <li className="ms-3">There are no level 0 data!</li>}
                </ul>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </FormGroup>
  </Form>

    // ---------------------------------------------------------- Mantain Log History ------------------------------
const postLogHistory = () =>{
  const param = {
    user_id : user_id,
    module_name : 'Manage User',
    operationPerformed : 'navigate to manage user screen',
  }
  axios.post('/postLogHistory',param);
}

  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getRoleList();
    getUserData();
    getTaskList();
    getProjectList();
    getMilestoneList();
    // postLogHistory();
  }, [])

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(userData?.password));
  }, [userData?.password])

  //--------------------------------------------------------- Html Start ------------------------------------------ 

  return (
    loading ? (
      <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
    ) :
   ( <>
    <TopHeader
    breadCrumb = {
      <>
          <li className="nav-item"><a onClick={() => navigate("/home")} className="nav-link">Home <BsChevronRight /></a></li> 
          <li className="nav-item"><span>Manage Users</span></li>
      </>
    }/>
  <SubHeader
        SubHeaderTitle="Manage User"
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        handleSubmit={postAddUser}
        SlideBarContent=''
        titleButton={`${userData?.updateId ?'Edit':'Add'} User`}
        showButton={((rolexModuleData?.find((data) => pathname === data?.description && data?.create === 1))|| roles?.find((data) => data?.role_id === 1001)) ? true : false}
        AddUserContent={
          userContent
        }
        userStatus={
          <ListInlineItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle className='activeuser' caret>{userStatus}</DropdownToggle>
              <DropdownMenu >
                <DropdownItem onClick={() => setUserStatus("Active")}>Active</DropdownItem>
                <DropdownItem onClick={() => setUserStatus("Inactive")}>Inactive</DropdownItem>
                <DropdownItem onClick={() => setUserStatus("All")}>All</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </ListInlineItem>
        } />
        <div id="portalUser" className="contentInnerWrap">
        <Row>
            <div className="usersCount">
              <span><b>Total Users: </b></span>
              <span> { userStatus === "All" ?  userDataList?.length :  userDataList?.filter((data => data?.isActive === (userStatus === "Active" ? '1': '0'))).length} </span>
            </div>
          </Row>
          <Row>
          {userDataList?.length > 0 ? ( userDataList?.filter((data) => { if (userStatus === 'All') { return true; } return data?.isActive === (userStatus === 'Active' ? '1' : '0'); })?.length > 0 ? (
    userDataList?.filter((data) => { if (userStatus === 'All') { return true; } return data?.isActive === (userStatus === 'Active' ? '1' : '0'); })?.map((data) => (
      <Col lg={3} Col md={6} className="clearfix" key={data?.user_id}>
        <div className='clientuser-wrap'>
          {isUpdateAccess && (
            <div className="actionBtn">
              <NavLink className='editicon' onClick={() => updateUserData(data?.user_id)}>
                <FaEdit />
              </NavLink>
            </div>
          )}
          <div className='clientImage'>
            <img alt="User Profile Images" src={data?.profile_image_url?.length > 0 ? (global.SERVER_URL + '/userImg/' + data?.profile_image_url) : Profile} />
          </div>
          <div className='client-details clearfix'>
            <div className="client-info">
              <NavLink href="#" title={data?.name}>{data?.name}</NavLink>
              <div className='client-id'>{data?.email_id}</div>
              <div className='client-id'>{data?.username}</div>
              <div className='client-id'>{data?.user_x_role?.map((data1, index) => (
                <span key={index}> {data1?.role_master?.[0]?.role} </span>
              ))}</div>
            </div>
            {isUpdateAccess && (
              <div className='button-wrap'>
                <button className={data?.isActive === '1' ? 'btn inactive' : 'btn active'} onClick={(e) => (data?.isActive === '1' ? updateActiveStatus(e, '0', data?.user_id) : updateActiveStatus(e, '1', data?.user_id))}>
                  {data?.isActive === '1' ? 'Inactive' : 'Active'}
                </button>
              </div>
            )}
            <div style={{ clear: 'both' }}></div>
          </div>
        </div>
      </Col>
    ))
  ) : (
    <div className="default-msg text-center">There are no {userStatus.toLowerCase()} users!</div>
  )
) : (
  <div className="default-msg text-center">There are no users available!</div>
)}


          </Row>
        </div>
    </>)
  )
}

export default ManageUsers